import React from 'react';
import loadingCircle from '../../images/loading_symbol_3.gif';

export const LoadingCircle = () => {
    return <div className='loading-animation'>
        <img src={loadingCircle} alt="page is loading" className="loading" />
    </div>;
}